module.exports = __webpack_public_path__ + "img/XK.7760d649.svg";